export default __webpack_public_path__ + "static/media/1175.571604e7.JPG";